import { CompositeScreenProps, useNavigation } from '@react-navigation/native'
import React, { useEffect, useState } from 'react'

import { BottomSheetNavbar } from 'partials/BottomSheetNavbar'

import { Box } from 'widgets/Box'
import { FlatList } from 'widgets/FlatList'
import { Pressable } from 'widgets/Pressable'
import { Text } from 'widgets/Text'

import { useActivityTypes } from 'hooks/useActivityTypes'
import { useNavigateBackOrHome } from 'hooks/useNavigateBackOrHome'

import { links } from 'utils/constants'
import commonStyles from 'utils/styles/commonStyles'

import { useCreatePostModal } from 'contexts/CreatePostModalContext'

export const ActivityTypeSelection = ({ route }: CompositeScreenProps<any, any>) => {
  const selectedGroup = route?.params?.selectedGroup

  const navigation = useNavigation<any>()
  const navigateBackOrHome = useNavigateBackOrHome()
  const createPostModalRef = useCreatePostModal()

  const { types: activityTypes } = useActivityTypes()
  const [selectedGroupTypes, setSelectedGroupTypes] = useState<string[]>([])

  useEffect(() => {
    if (!selectedGroup) return
    switch (selectedGroup.toLowerCase()) {
      case 'workout': {
        setSelectedGroupTypes(activityTypes.workout.types)
        break
      }
      case 'sport': {
        setSelectedGroupTypes(activityTypes.sport.types)
        break
      }
      case 'recovery': {
        setSelectedGroupTypes(activityTypes.recovery.types)
        break
      }
      case 'mindfulness': {
        setSelectedGroupTypes(activityTypes.mindfulness.types)
        break
      }
      default: {
        setSelectedGroupTypes([])
        break
      }
    }
  }, [
    activityTypes.mindfulness.types,
    activityTypes.recovery.types,
    activityTypes.sport.types,
    activityTypes.workout.types,
    selectedGroup,
  ])

  return (
    <Box testID='ActivityTypeSelectionPage' flexDirection='column' backgroundColor='white' flex={1}>
      <BottomSheetNavbar title={selectedGroup} onBack={navigateBackOrHome} />

      <Box testID='ActivityGroups' padding={{ top: 'sm' }} width='100%' justifyContent='center'>
        <Box margin={{ top: 'md', horizontal: 'lg' }}>
          {selectedGroupTypes.length ? (
            <FlatList<string>
              bounces={false}
              data={selectedGroupTypes}
              keyExtractor={(item, index) => `${item}-${index}`}
              renderItem={({ item, index }) => (
                <Pressable
                  style={commonStyles.fullWidth}
                  onPress={() => {
                    createPostModalRef?.current?.snapToIndex(2)
                    navigation.navigate(links.ACTIVITY_DETAILS_PAGE, {
                      selectedGroup,
                      selectedType: item,
                    })
                  }}
                >
                  <Box height={50} width='100%' align='center' justifyContent='center'>
                    <Text bold align='center' numberOfLines={1}>
                      {item}
                    </Text>
                    {index < selectedGroupTypes.length - 1 && (
                      <Box position='absolute' height='100%' width='100%' justifyContent='flex-end'>
                        <Box height={1} width='100%' backgroundColor='greyLight' />
                      </Box>
                    )}
                  </Box>
                </Pressable>
              )}
            />
          ) : null}
        </Box>
      </Box>
    </Box>
  )
}
